import { Refresh as RefreshIcon } from "@mui/icons-material";
import {
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import * as numbers from "common/numbers";
import Button from "components/common/Button";

const DIFF_KIND_CONFIG = {
  factor_removed: { label: "Rating category removed", color: "error.main" },
  category_removed: { label: "Field removed", color: "error.main" },
  value_changed: { label: "Value changed", color: "warning.main" },
  factor_added: { label: "New rating category", color: "info.main" },
  field_added: { label: "New field added", color: "info.main" },
};

const HEADERS = [
  "Rating Category",
  "Field Used",
  "Value at last pricing",
  "Current default value",
  "Change",
];

const StalePricingModal = ({ open, onClose, configDiff, onApplyLatest }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={"md"}
    fullWidth
    scroll={"paper"}
  >
    <DialogTitle sx={{ fontSize: "1rem", fontWeight: 700, pb: 1 }}>
      {"Default Configuration Changed"}
    </DialogTitle>
    <DialogContent dividers sx={{ p: 0 }}>
      <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
        <Typography fontSize={"0.8rem"} color={"text.secondary"}>
          {
            "The default engine configuration has changed since the last pricing calculation. Your saved pricing remains unchanged. Click "
          }
          <strong>{"Use Latest Configuration"}</strong>
          {
            " to update your settings, or recalculate to apply your current selections."
          }
        </Typography>
      </Box>
      <Table size={"small"}>
        <TableHead>
          <TableRow sx={{ bgcolor: "grey.50" }}>
            {HEADERS.map((h) => (
              <TableCell
                key={h}
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  color: "text.secondary",
                }}
              >
                {h}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {configDiff.map(
            ({
              type,
              displayName,
              category,
              lastFactor,
              currentFactor,
              kind,
            }) => {
              const { label, color } = DIFF_KIND_CONFIG[kind];
              return (
                <TableRow key={`${type}-${category}`}>
                  <TableCell sx={{ fontSize: "0.75rem" }}>
                    {displayName}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.75rem" }}>{category}</TableCell>
                  <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600 }}>
                    {lastFactor != null ? numbers.dpString(4)(lastFactor) : "—"}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: "0.75rem", color: "text.secondary" }}
                  >
                    {currentFactor != null
                      ? numbers.dpString(4)(currentFactor)
                      : "—"}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={label}
                      size={"small"}
                      sx={{
                        fontSize: "0.65rem",
                        height: 18,
                        bgcolor: color,
                        color: "white",
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            }
          )}
        </TableBody>
      </Table>
    </DialogContent>
    <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
      <Tooltip
        title={
          "Apply the current default configuration values, keeping existing selections where the category still exists and flagging those that have been removed"
        }
      >
        <Button
          startIcon={<RefreshIcon fontSize={"small"} />}
          onClick={onApplyLatest}
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          {"Use Latest Configuration"}
        </Button>
      </Tooltip>
      <Button onClick={onClose} sx={{ textTransform: "none", fontWeight: 600 }}>
        {"Close"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default StalePricingModal;
